/** Formatierungs- und String-Hilfsfunktionen. */

const AVATAR_COLORS = [
  '#2563EB', '#7C3AED', '#DB2777', '#DC2626',
  '#EA580C', '#D97706', '#65A30D', '#059669',
  '#0891B2', '#4F46E5', '#9333EA', '#C026D3',
];

export function getInitials(vorname?: string | null, nachname?: string | null): string {
  let i = '';
  if (vorname) i += vorname.charAt(0).toUpperCase();
  if (nachname) i += nachname.charAt(0).toUpperCase();
  return i || '??';
}

export function getAvatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function formatDate(value?: string | Date | null, locale = 'de-DE'): string {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatDateTime(value?: string | Date | null, locale = 'de-DE'): string {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(locale, {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function formatNumber(n: number | null | undefined, locale = 'de-DE'): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '';
  return new Intl.NumberFormat(locale).format(n);
}

export function formatCurrency(n: number | null | undefined, currency = 'EUR', locale = 'de-DE'): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '';
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(n);
}

/** Schlanker debounce für Inputs (300–500ms Bereich) */
export function debounce<A extends unknown[]>(fn: (...args: A) => void, ms: number) {
  let t: ReturnType<typeof setTimeout> | null = null;
  return (...args: A) => {
    if (t) clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}

export function classNames(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
